import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { orders } from "../../../../../../redux/orders/action";
import { selectOrdersListItems } from "../../../../../../redux/orders/selector";
import { selectListItems } from "../../../../../../redux/library/selector";
import PageLoader from "../../../../../../components/PageLoader";

const TransporterOrders = () => {
	const dispatch = useAppDispatch()
	const result = useSelector(selectCurrent)
  const [pageData, setPageData] = useState(1)
	const { header, footer, currency } = result
    const itemsData = useSelector(selectOrdersListItems)
    const libraryData = useSelector(selectListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          {  field: 'InvoiceNumber', headerName: 'Invoice Number', sortable: true, filter: true,isEdit: true  },
    { field: 'ShipmentPId', headerName: 'Shipment PId' },
    { field: 'CustomerName', headerName: 'Customer Name' },
    { field: 'TransporterName', headerName: 'Transporter Name' },
    { field: 'AgentName', headerName: 'Agent Name' },
    { field: 'TrackingNumber', headerName: 'Tracking Number', sortable: false, filter: true },
   
    {
      field: 'ShippingStatusId',
      headerName: 'Shipment Status',
      cellRenderer: 'libraryRendererComponent',
      cellRendererParams: { library: libraryData?.result?.ShippingStatus },
      sortable: true,
      filter: false,
    },
    // {
    //   field: 'Repeat Order',
    //   headerName: 'Repeat Order',
    //   cellRenderer: 'buttonRenderer',
    //   buttonName: 'Repeat order',
    // },
    // { field: 'Download Invoice', headerName: 'Download Invoice',PDFName: 'Download Invoice',isPrintandDownloadPDF:true },
    { field: 'ShippedDateUtc', headerName: 'Order Date', isDateValueFormat:true },
    { field: 'DeliveryDateUtc', headerName: 'Delivery Date', isDateValueFormat:true },
        ]);
      }
      const fetchOrders=()=>{
        dispatch(orders.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipments/list`,entity:'order',jsonData:{
          "PageNumber": pageData,
          "PageSize": 10,
          "SortField": "Id",
          "SortOrder": "desc",
                 
        "Filters": [
                    {
                      "FieldName": "TransporterId",
                      "FilterOperatorId": 1,
                      "FieldValue": 56,
                      "FieldType": "number"
                    }
                  ],
            }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchOrders()
		
	}, [pageData])

	return (
    <>
    {itemsData?.isLoading ? <PageLoader />
 : 
    <Table columnData={columnDefs} rowData={itemsData?.result?.items} setPageData={setPageData}
    paginationData={itemsData?.result?.pagination} headingName="Orders"/>
}
    </>
		
 
     
	);
};

export default TransporterOrders;


